<div class="input-container flex focus:outline-none relative w-full h-12 appearance-none">
  @if (formFieldPrefix()) {
    <div class="slot slot__prefix mr-2">
      <ng-content select="[efFormFieldPrefix]"></ng-content>
    </div>
  }

  <label
    class="text-gray-90 text-body-01 select-none pointer-events-none absolute left-0 top-0"
    [attr.for]="inputId()"
    >{{ label() }}</label
  >

  <div class="block relative w-full h-full">
    <ng-content></ng-content>
  </div>

  <fieldset
    class="duration-100 border border-gray-20 rounded absolute -top-1 right-0 bottom-0 left-0 pointer-events-none"
  >
    <legend class="text-body-02 ml-3 invisible">
      <span>{{ label() }}</span>
    </legend>
  </fieldset>

  @if (formFieldSuffix() || (isTouched() && isInvalid())) {
    <div class="slot slot__suffix ml-2 mr-3">
      @if (formFieldSuffix()) {
        <ng-content select="[efFormFieldSuffix]"></ng-content>
      } @else if (isTouched() && isInvalid()) {
        <!-- TODO: Zmienić na ikony z fonta! -->
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="error-icon"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0004 1.85002C5.49927 1.85002 1.85039 5.4989 1.85039 10C1.85039 14.5011 5.49927 18.15 10.0004 18.15C14.5015 18.15 18.1504 14.5011 18.1504 10C18.1504 5.4989 14.5015 1.85002 10.0004 1.85002ZM0.150391 10C0.150391 4.56002 4.56039 0.150024 10.0004 0.150024C15.4404 0.150024 19.8504 4.56002 19.8504 10C19.8504 15.44 15.4404 19.85 10.0004 19.85C4.56039 19.85 0.150391 15.44 0.150391 10Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0004 4.65002C10.4698 4.65002 10.8504 5.03058 10.8504 5.50002V10.75C10.8504 11.2195 10.4698 11.6 10.0004 11.6C9.53095 11.6 9.15039 11.2195 9.15039 10.75V5.50002C9.15039 5.03058 9.53095 4.65002 10.0004 4.65002Z"
          />
          <path
            d="M10.0004 15.25C10.6217 15.25 11.1254 14.7463 11.1254 14.125C11.1254 13.5037 10.6217 13 10.0004 13C9.37905 13 8.87537 13.5037 8.87537 14.125C8.87537 14.7463 9.37905 15.25 10.0004 15.25Z"
          />
        </svg>
      }
    </div>
  }
</div>

@if (isTouched() && (errors$ | async); as errors) {
  <div class="errors text-body-02 text-secondary" data-test-id="form-field-error" [innerHTML]="errors">
    {{ errors }}
  </div>
}
